<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.75 8.25H8.25V13.75H13.75V8.25Z" fill="#5E6A79" />
    <path
      d="M1.41663 4.58366C1.41663 3.74381 1.75026 2.93835 2.34412 2.34449C2.93799 1.75062 3.74344 1.41699 4.58329 1.41699H17.4166C18.2565 1.41699 19.0619 1.75062 19.6558 2.34449C20.2497 2.93835 20.5833 3.74381 20.5833 4.58366V17.417C20.5833 18.2568 20.2497 19.0623 19.6558 19.6562C19.0619 20.25 18.2565 20.5837 17.4166 20.5837H4.58329C3.74344 20.5837 2.93799 20.25 2.34412 19.6562C1.75026 19.0623 1.41663 18.2568 1.41663 17.417V4.58366ZM17.4166 2.25033H4.58329C3.96445 2.25033 3.37096 2.49616 2.93338 2.93374C2.49579 3.37133 2.24996 3.96482 2.24996 4.58366V17.417C2.24996 18.0358 2.49579 18.6293 2.93338 19.0669C3.37096 19.5045 3.96445 19.7503 4.58329 19.7503H17.4166C18.0355 19.7503 18.629 19.5045 19.0665 19.0669C19.5041 18.6293 19.75 18.0358 19.75 17.417V4.58366C19.75 3.96482 19.5041 3.37133 19.0665 2.93374C18.629 2.49616 18.0355 2.25033 17.4166 2.25033Z"
      fill="#5E6A79"
      stroke="#5E6A79"
    />
  </svg>
</template>

<script>
export default {
  name: "IconStop",
};
</script>

<style></style>
